import React from 'react';

const About: React.FC = () => {
  return (
    <div className="page-container">
      <div className="max-w-7xl mx-auto px-4 pb-12">
        <h1 className="text-4xl md:text-5xl font-bold mb-8 text-center">
          <span className="gradient-text">About Just Vibes</span>
        </h1>
        <div className="max-w-4xl mx-auto">
                      <p className="text-xl text-text-secondary mb-8 text-center">
              A 6-hour mid-core guild that has been in business since the start of Dragonflight, 
              striving to reach Cutting Edge while maintaining a fun, relaxed atmosphere.
            </p>
          <div className="glass p-8 rounded-xl">
            <h2 className="text-2xl font-semibold mb-4">Our Story</h2>
            <p className="text-text-secondary mb-6">
              Just Vibes has been in business since the start of Dragonflight, growing from a small group 
              of friends into a thriving mid-core guild. We believe that raiding should be both challenging 
              and enjoyable, which is why we maintain a relaxed atmosphere while still pushing for Cutting Edge 
              achievements. Our 6-hour raid schedule allows us to focus on progression without burning out.
            </p>
            <h2 className="text-2xl font-semibold mb-4">Our Values</h2>
            <ul className="text-text-secondary space-y-3 list-none">
              <li className="flex items-center">
                <span className="neon-cyan-text mr-3 mt-1">•</span>
                <span className="mt-1">Excellence in raiding and gameplay</span>
              </li>
              <li className="flex items-center">
                <span className="neon-cyan-text mr-3 mt-1">•</span>
                <span className="mt-1">Inclusive and supportive community</span>
              </li>
              <li className="flex items-center">
                <span className="neon-cyan-text mr-3 mt-1">•</span>
                <span className="mt-1">Professional organization and communication</span>
              </li>
              <li className="flex items-center">
                <span className="neon-cyan-text mr-3 mt-1">•</span>
                <span className="mt-1">Continuous improvement and learning</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About; 